import { render, staticRenderFns } from "./BoxRoomBaseRate.vue?vue&type=template&id=7774e863&scoped=true&"
import script from "./BoxRoomBaseRate.vue?vue&type=script&lang=ts&"
export * from "./BoxRoomBaseRate.vue?vue&type=script&lang=ts&"
import style0 from "./BoxRoomBaseRate.vue?vue&type=style&index=0&id=7774e863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7774e863",
  null
  
)

export default component.exports